import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-6 px-4 border-t" style={{ backgroundColor: '#213b36', borderColor: '#2d4a44' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left: Tagline */}
          <p className="text-xs max-w-md text-center md:text-left leading-relaxed" style={{ color: '#f1e9dd' }}>
            Business exit planning and strategic consulting to help you build a business that blesses beyond the bottom line and leaves a lasting legacy.
          </p>

          {/* Center: Logo */}
          <a
            href="https://www.dominionbusinessadvisors.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-80 flex-shrink-0 min-h-[44px] flex items-center"
          >
            <img
              src="/Login Logo.png"
              alt="Dominion Business Advisors"
              className="h-10 sm:h-12 w-auto"
            />
          </a>

          {/* Right: Copyright */}
          <p className="text-xs text-center md:text-right" style={{ color: '#f1e9dd' }}>
            © 2025 Dominion Business Advisors LLC. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
